require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./constants"));
	else if(typeof define === 'function' && define.amd)
		define(["./constants"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./constants")) : factory(root["./constants"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__27__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[73],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getKeyName = getKeyName;
exports.isKey = isKey;

var _constants = __webpack_require__(27);

exports.keyNames = _constants.keyNames;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function getKeyName(e) {
  if (e.type === 'keydown' || e.type === 'keyup' || e.type === 'keypress') {
    const {
      BACKSPACE,
      TAB,
      ENTER,
      ESCAPE,
      SPACE,
      END,
      HOME,
      LEFT,
      UP,
      RIGHT,
      DOWN,
      A,
      F10,
      NOT_RECOGNIZED,
      SHIFT
    } = _constants.keyNames;

    switch (e.keyCode || e.which // older browser does not support e.keyCode
    ) {
      case 8:
        return BACKSPACE;

      case 9:
        return TAB;

      case 13:
        return ENTER;

      case 16:
        return SHIFT;

      case 27:
        return ESCAPE;

      case 32:
        return SPACE;

      case 35:
        return END;

      case 36:
        return HOME;

      case 37:
        return LEFT;

      case 38:
        return UP;

      case 39:
        return RIGHT;

      case 40:
        return DOWN;

      case 65:
        return A;

      case 121:
        return F10;

      default:
        return NOT_RECOGNIZED;
    }
  } else {
    console.warn(`this event ${e} is not a keydown event`);
  }
}

function isKey(e, keyName) {
  return getKeyName(e) === keyName;
}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(598));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const PREFIX = 'is-';

function prefix(cls) {
  if (cls.length === 0 || cls.indexOf('-') >= 0 || cls.substr(0, 3) === 'is-') {
    return cls;
  }

  return `${PREFIX}${cls}`;
}
/**
 * Follows the same behavior as the normal 'classnames' library. If a classname has no hyphens then it is considered
 * a modifier and thereby prefixed with 'is-'.
 */


var _default = (...args) => {
  for (let i = 0; i < args.length; i++) {
    const arg = args[i];

    if (typeof arg === 'string') {
      args[i] = prefix(arg);
    } else if (arg && typeof arg === 'object') {
      args[i] = {};
      Object.keys(arg).forEach(key => args[i][prefix(key)] = arg[key]);
    }
  }

  return (0, _classnames.default)(...args);
};

exports.default = _default;

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _lodash = __webpack_require__(31);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/**
 *   Utils which allow to control bidi-specific features: btd, stt, numeric shaping
 */

/* eslint no-underscore-dangle: 'off' */
const DEFAULT_DIR = '';
const DEFAULT_BTD = '';
const DEFAULT_G11N = 'default';
const LTR = 'ltr';
const RTL = 'rtl';
const CONTEXTUAL = 'contextual';
const AUTO = 'auto';
const EUROPIAN = 0;
const INDIC = 1;
const LRE = '\u202A';
const RLE = '\u202B';
const PDF = '\u202C';
const LRM = '\u200E';
const RLM = '\u200F';
const REG_DIR = /[A-Za-z\u05d0-\u065f\u066a-\u06ef\u06fa-\u07ff\ufb1d-\ufdff\ufe70-\ufefc]/; // eslint-disable-next-line no-control-regex, no-misleading-character-class

const REG_SH = /([0-9])|([\u0660-\u0669])|([\u0590-\u05FF\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE]+)|([^0-9\u0590-\u05FF\u0660-\u0669\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE\u0600-\u0607\u0609-\u060A\u060C\u060E-\u061A\u064B-\u066C\u0670\u06D6-\u06E4\u06E7-\u06ED\u06F0-\u06F9\u08E4-\u08FF\uFD3E-\uFD3F\uFDD0-\uFDEF\uFDFD\uFEFF\u0000-\u0040\u005B-\u0060\u007B-\u007F\u0080-\u00A9\u00AB-\u00B4\u00B6-\u00B9\u00BB-\u00BF\u00D7\u00F7\u02B9-\u02BA\u02C2-\u02CF\u02D2-\u02DF\u02E5-\u02ED\u02EF-\u02FF\u2070\u2074-\u207E\u2080-\u208E\u2100-\u2101\u2103-\u2106\u2108-\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A-\u213B\u2140-\u2144\u214A-\u214D\u2150-\u215F\u2189\uA720-\uA721\uA788\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE]+)/g;
const computedDirection = window.getComputedStyle && window.getComputedStyle(document.documentElement).direction;

function hasArabicChar(text, after) {
  if (!text) {
    return false;
  }

  let result = '';

  if (after) {
    const ind = text.indexOf(after);

    if (ind > 0 && ind < text.length - 1) {
      result = text.substring(ind + 1);
    }
  }

  const fdc = /[\u0600-\u065f\u066a-\u06ef\u06fa-\u07ff\ufb1d-\ufdff\ufe70-\ufefc]/.exec(result);
  return !!fdc;
}

class TextSegment {
  constructor(text, flowDir, segDir, isSeparator = false) {
    this.text = text;
    const guiDir = Bidi.isMirroredUI() ? RTL : LTR;
    this.flowDir = flowDir === DEFAULT_DIR ? guiDir : flowDir;
    this.segDir = segDir === DEFAULT_DIR ? this.flowDir : segDir;
    this.isSeparator = isSeparator;
  }

}

class Bidi {
  constructor(...props) {
    this._props = props;
  }

  static get AS_STRING() {
    return 1;
  }

  static get AS_HTML() {
    return 2;
  }

  static get AS_JSX() {
    return 3;
  }

  static get DIR_DEFAULT() {
    return DEFAULT_DIR;
  }

  static get DIR_LTR() {
    return LTR;
  }

  static get DIR_RTL() {
    return RTL;
  }

  static get DIR_CONTEXTUAL() {
    return CONTEXTUAL;
  }

  static get DIR_AUTO() {
    return AUTO;
  }

  static get FREETEXT() {
    return '0';
  }

  static get BREADCRUMB() {
    return '1';
  }

  static get COMMA() {
    return '2';
  }

  static get EMAIL() {
    return '3';
  }

  static get FILEPATH() {
    return '4';
  }

  static get FORMULA() {
    return '5';
  }

  static get UNDERSCORE() {
    return '6';
  }

  static get URL() {
    return '7';
  }

  static get WORD() {
    return '8';
  }

  static get FILENAME() {
    return '9';
  }

  static get CUSTOM() {
    return '99';
  }

  static getTextDir(btd) {
    const _btd = btd || Bidi._getTextDir();

    if (!Bidi.isBidi() || _btd === DEFAULT_BTD || _btd === DEFAULT_G11N) {
      return DEFAULT_BTD;
    } else if (_btd !== CONTEXTUAL && _btd !== AUTO) {
      return _btd;
    }

    return AUTO;
  }

  static getDir(dir) {
    const _dir = dir || Bidi._getDir();

    if (!Bidi.isBidi() || _dir === DEFAULT_DIR || _dir === DEFAULT_G11N) {
      return DEFAULT_DIR;
    } else if (_dir !== CONTEXTUAL && _dir !== AUTO) {
      return _dir;
    }

    return AUTO;
  }

  static resolveDir(txt, dir) {
    let text = txt;

    if (typeof text === 'number') {
      text = `${text}`;
    }

    const _dir = dir || Bidi.getDir();

    if (text === null || text === undefined || !Bidi.isBidi() || _dir === DEFAULT_DIR || _dir === DEFAULT_G11N) {
      return DEFAULT_DIR;
    } else if (_dir !== CONTEXTUAL && _dir !== AUTO) {
      return _dir;
    }

    const fdc = REG_DIR.exec(text);

    if (fdc) {
      return fdc[0] <= 'z' ? LTR : RTL;
    }

    return Bidi.isMirroredUI() ? RTL : LTR;
  }

  static resolveTextDir(txt, pageTextDir, textDir) {
    let text = txt;

    if (typeof text === 'number') {
      text = `${text}`;
    }

    const btd = textDir || pageTextDir || Bidi.getTextDir();

    if (text === null || text === undefined || !Bidi.isBidi() || btd === DEFAULT_DIR || btd === DEFAULT_G11N) {
      return DEFAULT_DIR;
    } else if (btd !== CONTEXTUAL && btd !== AUTO) {
      return btd;
    }

    const fdc = REG_DIR.exec(text);

    if (fdc) {
      return fdc[0] <= 'z' ? LTR : RTL;
    }

    return Bidi.isMirroredUI() ? AUTO : LTR;
  }

  static resolveNumShape(pageNumShape, numShape) {
    const ns = numShape || pageNumShape || Bidi.getNumShape();

    if (typeof ns === 'string') {
      return String(ns) === 'true';
    }

    return ns;
  }

  static enforceDir(txt, outType, dir, reshape = false, startKey = 0) {
    let text = txt;

    if (typeof text === 'number') {
      text = `${text}`;
    }

    const btd = Bidi.resolveDir(text, dir);

    if (!Bidi.isBidi() || !text || btd === DEFAULT_DIR) {
      return Bidi.reshape(text, reshape);
    } else if (outType === Bidi.AS_STRING) {
      return (btd === RTL ? RLE : LRE) + Bidi.reshape(text, reshape) + PDF;
    } else if (outType === Bidi.AS_HTML) {
      return `<bdi dir='${btd}'>${Bidi.reshape(text, reshape)}</bdi>`;
    }

    return /*#__PURE__*/_react.default.createElement("bdi", {
      key: `${startKey}`,
      dir: btd
    }, Bidi.reshape(text, reshape));
  }

  static reshape(txt, needReshape = true, needUnshape = false) {
    let text = txt;

    if (typeof text === 'number') {
      text = `${text}`;
    }

    if (!text || !Bidi.isBidi() && !needUnshape || !needReshape && !needUnshape) {
      return text;
    }

    const userLang = Bidi.getUserLanguage();
    const browserLang = window.navigator.languages ? window.navigator.languages[0] : window.navigator.language || window.navigator.userLanguage;
    let nsType = userLang.substring(0, 2).toLowerCase() === 'ar' ? INDIC : EUROPIAN;
    let country = '';

    if (userLang.length > 2) {
      country = userLang.substring(3);
    } else if (browserLang.length > 2) {
      country = browserLang.substring(3);
    }

    const useLatin = ['DZ', 'EH', 'LY', 'MA', 'TN'].some(item => item === country.toUpperCase());

    if (useLatin) {
      nsType = EUROPIAN;
    }

    if (needUnshape) {
      nsType = EUROPIAN;
    }

    const result = text.replace(REG_SH, (curChs, latNum, araNum) => {
      if (araNum) {
        if (nsType === EUROPIAN) {
          return araNum.charCodeAt(0) - 1632;
        }

        return araNum;
      } else if (latNum) {
        if (nsType === INDIC) {
          return String.fromCharCode(parseInt(latNum, 10) + 1632);
        }

        return latNum;
      }

      return curChs;
    });
    return result;
  }

  static isolate(text, outType, dir, startKey = 0) {
    const outDir = Bidi.isMirroredUI() ? RTL : LTR;
    const guiDir = dir || outDir;

    if (!text || !Bidi.isBidi()) {
      return text;
    } else if (outType === Bidi.AS_STRING) {
      const mark = guiDir === RTL ? RLM : LRM;
      return mark + text + mark;
    } else if (outType === Bidi.AS_HTML) {
      return `<span style="direction: ${guiDir}; unicode-bidi: embed;"></span>${text}<span style="direction: ${guiDir}; unicode-bidi: embed;"></span>`;
    }

    const spStyle = {
      direction: guiDir,
      unicodeBidi: 'embed'
    };
    const result = [];
    result.push( /*#__PURE__*/_react.default.createElement("span", {
      key: startKey * 100 + 1,
      style: spStyle
    }));
    result.push( /*#__PURE__*/_react.default.createElement("span", {
      key: startKey * 100 + 2
    }, text));
    result.push( /*#__PURE__*/_react.default.createElement("span", {
      key: startKey * 100 + 3,
      style: spStyle
    }));
    return result;
  }

  static parse(text, sttType, delimiters, flowDir, segDir, findFromEnd, stopIn) {
    const results = [new TextSegment(text, flowDir, segDir)];
    const dels = (0, _lodash.isString)(delimiters) ? delimiters.split('') : delimiters;
    let count = 0;
    let ind = 0;
    let offset = 0;
    let curDel = '';
    let point = ''; // eslint-disable-next-line no-constant-condition

    while (true) {
      const actInd = findFromEnd ? results.length - ind - 1 : ind;

      if (results[actInd].isSeparator) {
        ind += 1;

        if (ind === results.length) {
          break;
        } else {
          continue; // eslint-disable-line no-continue
        }
      }

      const curText = results[actInd].text;
      curDel = '';
      offset = findFromEnd ? -1 : curText.length;
      let found = false;
      let i = 0;

      for (i = 0; i < dels.length; i++) {
        point = dels[i];
        const delOffset = findFromEnd ? curText.lastIndexOf(point) : curText.indexOf(point);

        if (delOffset < 0) {
          continue; // eslint-disable-line no-continue
        } else if (findFromEnd && delOffset > offset || !findFromEnd && delOffset < offset) {
          offset = delOffset;
          curDel = point;
          found = true;
        }
      }

      if (found) {
        results.splice(actInd + 1, 0, new TextSegment(curDel, flowDir, flowDir, true));

        if (curText.length > offset + curDel.length) {
          results.splice(actInd + 2, 0, new TextSegment(curText.substring(offset + curDel.length), flowDir, segDir));
        }

        results[actInd].text = curText.substring(0, offset);
        count += 1;

        if (stopIn > 0 && count === stopIn) {
          break;
        }
      }

      ind += 1;

      if (ind === results.length) {
        break;
      } else {
        continue; // eslint-disable-line no-continue
      }
    }

    return results;
  }

  static handleSTT(text, outType, sttType, pdelimiters = '', pflowDir = DEFAULT_DIR, psegDir = DEFAULT_DIR, pfindFromEnd = false, pstopIn = 0) {
    if (!text || !Bidi.isBidi() || sttType === Bidi.FREETEXT) {
      return text;
    }

    let delimiters = pdelimiters;
    let flowDir = pflowDir;
    const segDir = psegDir;
    let findFromEnd = pfindFromEnd;
    let stopIn = pstopIn;
    const guiDir = Bidi.isMirroredUI() ? RTL : LTR;

    switch (sttType) {
      case Bidi.EMAIL:
        delimiters = '<>.:,;@';
        flowDir = Bidi.getUserLanguage() === 'ar' && hasArabicChar(text, '@') ? RTL : LTR;
        break;

      case Bidi.FILEPATH:
        delimiters = '/\\:.';
        flowDir = LTR;
        break;

      case Bidi.FORMULA:
        delimiters = ' /%^&[]<>=!?~:.,|()+-*{}';
        flowDir = LTR;
        break;

      case Bidi.URL:
        delimiters = ':?#/@.[]=&';
        flowDir = LTR;
        break;

      case Bidi.BREADCRUMB:
        flowDir = flowDir === DEFAULT_DIR ? guiDir : flowDir;

        if (!delimiters) {
          delimiters = flowDir === RTL ? [' < ', ' | '] : [' > ', ' | '];
        }

        break;

      case Bidi.WORD:
        delimiters = ' ,.!?;:';
        break;

      case Bidi.COMMA:
        delimiters = ',';
        break;

      case Bidi.UNDERSCORE:
        delimiters = '_';
        break;

      case Bidi.FILENAME:
        delimiters = '.';
        flowDir = LTR;
        findFromEnd = true;
        stopIn = 1;
        break;

      case Bidi.CUSTOM:
        if (!delimiters) {
          return text;
        }

        break;

      default:
        return text;
    }

    const segments = Bidi.parse(text, sttType, delimiters, flowDir, segDir, findFromEnd, stopIn);
    const results = [];
    let i = 0;

    for (i = 0; i < segments.length; i++) {
      const segment = segments[i];
      let txt = segment.text;
      const actDir = segment.flowDir !== segment.segDir ? Bidi.resolveDir(txt, segment.segDir) : segment.flowDir;

      if (!segment.isSeparator) {
        if (actDir !== segment.flowDir) {
          txt = Bidi.enforceDir(txt, outType, actDir, false, i);
        }
      } else {
        txt = Bidi.isolate(txt, outType, segment.flowDir, i);
      }

      results.push(txt);
    }

    if (outType !== Bidi.AS_JSX) {
      let res = results.join('');

      if (outType === Bidi.AS_STRING) {
        res = (Bidi.resolveDir(res, flowDir) === RTL ? RLE : LRE) + res + PDF;
      } else {
        res = `<bdi dir='${flowDir}'>${res}</bdi>`;
      }

      return res;
    }

    return /*#__PURE__*/_react.default.createElement("bdi", {
      dir: flowDir
    }, results);
  }

  static removeUCC(text) {
    if (!text) {
      return text;
    }

    return text.replace(/(['\u202A' | '\u202B' | '\u202C' | '\u200E' | '\u200F'])/g, '');
  }

  static isBidiMark(text) {
    if (!text) {
      return false;
    }

    return ['\u202A', '\u202B', '\u202C', '\u200E', '\u200F'].some(item => item === text.charAt(0));
  }

  static checkDels(event) {
    const key = event.keyCode || event.charCode;

    if (key !== 8 && key !== 46) {
      return;
    }

    const text = event.target.value;
    let start = event.target.selectionStart;
    const end = event.target.selectionEnd;
    let as = start;
    const offs = key === 8 ? -1 : 1;

    if (start !== end) {
      return;
    }

    if (key === 8) {
      // backsp
      as -= 1;
    }

    while (as >= 0 && Bidi.isBidiMark(text.charAt(as))) {
      start += offs;
      as += offs;
    }

    event.target.selectionStart = start;
    event.target.selectionEnd = start;
  }

  static getDefBidi() {
    return false;
  }

  static isBidi() {
    if (Bidi.hasInitParams()) {
      return Bidi.getCustBidi();
    } else {
      return Bidi.getDefBidi();
    }
  }

  static getCustBidi() {
    return Bidi.custBidi;
  }

  static getCustBTD() {
    return Bidi.custBTD;
  }

  static getDefDir() {
    if (Bidi.isMirroredUI()) {
      return RTL;
    } else {
      return LTR;
    }
  }

  static getDefBTD() {
    if (Bidi.isMirroredUI()) {
      return 'auto';
    } else {
      return '';
    }
  }

  static _getTextDir() {
    if (Bidi.hasInitParams()) {
      return Bidi.getCustBTD();
    } else {
      return Bidi.getDefBTD();
    }
  }

  static getNumShape() {
    if (Bidi.custNumShape) {
      return Bidi.custNumShape;
    } else {
      return Bidi.getDefNumShape();
    }
  }

  static getDefNumShape() {
    if (Bidi.getUserLanguage() === 'ar') {
      return true;
    }

    return false;
  }

  static hasInitParams() {
    if (typeof Bidi.custBTD !== 'undefined' && typeof Bidi.custBidi !== 'undefined') {
      return true;
    } else {
      return false;
    }
  }

  static initParams(bidi, btd, lang, numShape) {
    Bidi.custBTD = btd;
    Bidi.custBidi = bidi;
    Bidi.custLang = lang;

    if (numShape && Bidi.getUserLanguage() === 'ar') {
      Bidi.custNumShape = numShape;
    } else {
      Bidi.custNumShape = false;
    }
  }

  static _getDir() {
    if (Bidi.getCustDir) {
      return Bidi.getCustDir();
    } else {
      return Bidi.getDefDir();
    }
  }

  static getDefLang() {
    const html = document.documentElement;

    if (html.lang) {
      return html.lang;
    } else {
      return window.navigator.languages ? window.navigator.languages[0] : window.navigator.language || window.navigator.userLanguage;
    }
  }

  static getUserLanguage() {
    if (Bidi.custLang) {
      return Bidi.custLang;
    } else {
      return Bidi.getDefLang();
    }
  }

  static isMirroredUI() {
    const html = document.documentElement;

    if (window.getComputedStyle) {
      return computedDirection === RTL;
    } else if (html.dir) {
      return html.dir === RTL;
    } else {
      return false;
    }
  }

  static getBidiProps() {
    return ['dir', 'pagedir', 'pageTextDir', 'textDir', 'numShape', 'pageNumShape'];
  }

}

exports.default = Bidi;

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hoistInstance;

var _lodash = __webpack_require__(18);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const REACT_FUNCTIONS = {
  autobind: 1,
  childContextTypes: 1,
  componentDidMount: 1,
  componentDidUpdate: 1,
  componentWillMount: 1,
  componentWillReceiveProps: 1,
  componentWillUnmount: 1,
  componentWillUpdate: 1,
  contextTypes: 1,
  displayName: 1,
  forceUpdate: 1,
  getChildContext: 1,
  getDefaultProps: 1,
  getInitialState: 1,
  isMounted: 1,
  mixins: 1,
  render: 1,
  replaceProps: 1,
  replaceState: 1,
  setProps: 1,
  setState: 1,
  shouldComponentUpdate: 1,
  statics: 1,
  updateComponent: 1
};

function hoistInstance(dest, source) {
  (0, _lodash.forIn)(source, (v, key) => {
    if (typeof source[key] === 'function' && key.charAt(0) !== '_' && !REACT_FUNCTIONS[key] && dest[key] === undefined) {
      dest[key] = source[key].bind(source); // eslint-disable-line no-param-reassign
    }
  });
}

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__27__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toPairs = exports.uniqueId = exports.throttle = exports.sortBy = exports.result = exports.range = exports.groupBy = exports.pick = exports.omit = exports.isString = exports.isEqual = exports.isEmpty = exports.indexOf = exports.get = exports.forOwn = exports.forIn = exports.findIndex = exports.filter = exports.fill = exports.extend = exports.debounce = exports.cloneDeep = exports.clamp = exports.assign = void 0;

var _lodash = __webpack_require__(18);

exports.assign = _lodash.assign;
exports.clamp = _lodash.clamp;
exports.cloneDeep = _lodash.cloneDeep;
exports.debounce = _lodash.debounce;
exports.extend = _lodash.extend;
exports.fill = _lodash.fill;
exports.filter = _lodash.filter;
exports.findIndex = _lodash.findIndex;
exports.forIn = _lodash.forIn;
exports.forOwn = _lodash.forOwn;
exports.get = _lodash.get;
exports.indexOf = _lodash.indexOf;
exports.isEmpty = _lodash.isEmpty;
exports.isEqual = _lodash.isEqual;
exports.isString = _lodash.isString;
exports.omit = _lodash.omit;
exports.pick = _lodash.pick;
exports.groupBy = _lodash.groupBy;
exports.range = _lodash.range;
exports.result = _lodash.result;
exports.sortBy = _lodash.sortBy;
exports.throttle = _lodash.throttle;
exports.uniqueId = _lodash.uniqueId;
exports.toPairs = _lodash.toPairs;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(595);


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.event = exports.arrayFilters = exports.listHelper = exports.mathUtils = exports.lodash = exports.keyboardUtils = exports.cssUtils = exports.propsUtils = exports.domUtils = exports.bidiUtils = void 0;

var bidiUtils = _interopRequireWildcard(__webpack_require__(596));

exports.bidiUtils = bidiUtils;

var domUtils = _interopRequireWildcard(__webpack_require__(597));

exports.domUtils = domUtils;

var propsUtils = _interopRequireWildcard(__webpack_require__(599));

exports.propsUtils = propsUtils;

var cssUtils = _interopRequireWildcard(__webpack_require__(600));

exports.cssUtils = cssUtils;

var keyboardUtils = _interopRequireWildcard(__webpack_require__(201));

exports.keyboardUtils = keyboardUtils;

var lodash = _interopRequireWildcard(__webpack_require__(31));

exports.lodash = lodash;

var mathUtils = _interopRequireWildcard(__webpack_require__(601));

exports.mathUtils = mathUtils;

var listHelper = _interopRequireWildcard(__webpack_require__(602));

exports.listHelper = listHelper;

var _Bidi = _interopRequireDefault(__webpack_require__(203));

exports.Bidi = _Bidi.default;

var arrayFilters = _interopRequireWildcard(__webpack_require__(603));

exports.arrayFilters = arrayFilters;

var _StringResource = _interopRequireDefault(__webpack_require__(604));

exports.StringResource = _StringResource.default;

var event = _interopRequireWildcard(__webpack_require__(607));

exports.event = event;

var _classnames = _interopRequireDefault(__webpack_require__(202));

exports.classnames = _classnames.default;

var _hoistNonReactInstanceFunctions = _interopRequireDefault(__webpack_require__(204));

exports.hoistNonReactInstanceFunctions = _hoistNonReactInstanceFunctions.default;

var _reactify = _interopRequireDefault(__webpack_require__(608));

exports.reactify = _reactify.default;

var _delayMount = _interopRequireDefault(__webpack_require__(609));

exports.delayMount = _delayMount.default;

var _debounceInput = _interopRequireDefault(__webpack_require__(610));

exports.debounceInput = _debounceInput.default;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.resolveBaseTextDir = resolveBaseTextDir;
exports.RTL = exports.LTR = exports.AUTO = void 0;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * borrowed from core-client, which borrowed from cclcore.
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const AUTO = 'auto';
exports.AUTO = AUTO;
const LTR = 'ltr';
exports.LTR = LTR;
const RTL = 'rtl';
exports.RTL = RTL;
const documentTextDir = document.documentElement.getAttribute('data-pref-text-dir');
/**
 * Checks if the character passed in is an Arabic character.
 * @param {string} charCode - Character code
 * @return {boolean} True, if character is an Arabic character
 */

function isArabicChar(charCode) {
  if (charCode >= 0x0600 && charCode <= 0x0669 || charCode >= 0x06fa && charCode <= 0x07ff || charCode >= 0xfb50 && charCode <= 0xfdff || charCode >= 0xfe70 && charCode <= 0xfefc) {
    return true;
  }

  return false;
}
/**
 * Checks if the character passed in is a Hebrew character.
 * @param {string} charCode - Character code
 * @return {boolean} True, if character is a Hebrew character
 */


function isHebrewChar(charCode) {
  if (charCode >= 0x05d0 && charCode <= 0x05ff) {
    return true;
  }

  return false;
}
/**
 * Checks if the character passed in is a BiDi character.
 * @param  {number}  charCode - character code
 * @return {boolean} True, if the character is a BiDi (Arabic or Hebrew) character
 */


function isBidiChar(charCode) {
  return isArabicChar(charCode) || isHebrewChar(charCode);
}
/**
 * Checks if the character passed in is a Latin character (Only treats
 * capital and lower case alphabets as latin characters)
 * @param  {number}  charCode - Character code
 * @return {boolean} True, if the character is a Latin character
 */


function isLatinChar(charCode) {
  if (charCode > 64 && charCode < 91 || charCode > 96 && charCode < 123) {
    return true;
  }

  return false;
}
/**
 * Checks if the character passed in is an Asian character
 * The ranges of Unicode characters which are routinely used for Chinese and Japanese text are:
 * U+3040 - U+30FF: hiragana and katakana (Japanese only)
 * U+3400 - U+4DBF: CJK unified ideographs extension A (Chinese, Japanese, and Korean)
 * U+4E00 - U+9FFF: CJK unified ideographs (Chinese, Japanese, and Korean)
 * U+F900 - U+FAFF: CJK compatibility ideographs (Chinese, Japanese, and Korean)
 * U+FF66 - U+FF9F: half-width katakana (Japanese only)
 * @param  {char}   char- Character
 * @return {boolean} True, if the character is an Asian character
 */


function isAsianChar(char) {
  return /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/.test(char);
}
/**
 * Traverses the string passed in as parameter from the beginning and
 * determines the direction of the text based on the first strong character
 * @param  {string} text - A bi-directional text
 * @param  {string} textDirParam - desired text direction
 * @param  {bool} isTextArea - Does the text belong to a textarea
 * @return {string} Direction of the text
 */


function resolveBaseTextDir(text, textDirParam, isTextArea) {
  const textDir = documentTextDir || textDirParam || AUTO;

  if (textDir === AUTO && !isTextArea) {
    for (let i = 0; text && i < text.length; i++) {
      const character = text.charCodeAt(i);

      if (isBidiChar(character)) {
        return RTL;
      }

      if (isLatinChar(character)) {
        return LTR;
      }

      if (isAsianChar(text[i])) {
        return LTR;
      }
    }
  }

  return textDir;
}

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.getNearestPositionedParent = getNearestPositionedParent;
exports.getTransformedParentElement = getTransformedParentElement;
exports.getPathToRoot = getPathToRoot;
exports.scrollLock = scrollLock;
exports.scrollUnlock = scrollUnlock;
exports.getEventClientOffset = getEventClientOffset;
exports.getNodeClientOffset = getNodeClientOffset;
exports.getNodeDepth = getNodeDepth;
exports.getElementCenter = getElementCenter;
exports.getElementTopLeft = getElementTopLeft;
exports.getElementBottomLeft = getElementBottomLeft;
exports.offsetWithinBoundingRect = offsetWithinBoundingRect;
exports.applyAttributes = applyAttributes;
exports.scrollIntoViewIfNeeded = scrollIntoViewIfNeeded;
exports.isElementInView = isElementInView;
exports.enableFocusLoop = enableFocusLoop;
exports.resetFocusLoop = resetFocusLoop;
exports.getFocusableElements = getFocusableElements;
exports.availableSpace = availableSpace;
exports.autoPosition = autoPosition;
exports.fromNodelistToArray = fromNodelistToArray;
exports.setFocus = setFocus;
exports.disableFocusLoop = disableFocusLoop;
exports.computeTopWith = computeTopWith;
exports.computeLeftWith = computeLeftWith;
exports.computeWidthOf = computeWidthOf;
exports.IE11 = void 0;

var _keyboardUtils = __webpack_require__(201);

var _classnames = _interopRequireDefault(__webpack_require__(202));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const IE11 = !!window.MSInputMethodContext && !!document.documentMode;
exports.IE11 = IE11;

function getNearestPositionedParent(el) {
  let curEl = el.parentElement;

  while (curEl) {
    if (window.getComputedStyle(curEl).position !== 'static') {
      return curEl;
    }

    curEl = curEl.parentElement;
  }

  return document.body;
}
/**
 * Get the nearest parent element which has a CSS transform applied. If no such parent exists returns null.
 */


function getTransformedParentElement(node) {
  let el = node;

  do {
    if (el.nodeType === Node.ELEMENT_NODE && (el.style.transform || window.getComputedStyle(el).transform !== 'none')) {
      return el;
    }

    el = el.parentNode;
  } while (el);

  return null;
}
/**
 * Get a list of all parent nodes.
 */


function getPathToRoot(node) {
  const path = [];
  let p = node;

  while (p) {
    path.push(p);
    p = p.parentNode;
  }

  return path;
}

function isScrollableOverFlow(overflow) {
  return overflow === 'scroll' || overflow === 'auto';
}

function isScrollableNode(node) {
  const {
    overflowX,
    overflowY,
    overflow
  } = window.getComputedStyle(node);
  return isScrollableOverFlow(overflowX) || isScrollableOverFlow(overflowY) || isScrollableOverFlow(overflow);
} // an array of scroll locks


const scrollLocks = [];
/**
 * Determine whether or not the list of nodes contains a scrollable element iff the list also contains the current scroll lock.
 */

function hasScrollableElement(pathNodes) {
  const lockIndex = pathNodes.indexOf(scrollLocks[scrollLocks.length - 1]);

  for (let i = 0; i <= lockIndex; ++i) {
    if (pathNodes[i].nodeType === Node.ELEMENT_NODE) {
      const node = pathNodes[i];

      if (isScrollableNode(node)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * An event listener that prevents scrolling unless the event target is a child of the current scroll lock.
 */


function scrollLockHandler(e) {
  if (e.cancelable) {
    const {
      tagName
    } = e.target;

    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !hasScrollableElement(getPathToRoot(e.target))) {
      e.preventDefault();
    }
  }
}

function scrollLockHandlerKeyDown(e) {
  if (e.keyCode >= 37 && e.keyCode <= 40) {
    scrollLockHandler(e);
  }
}
/**
 * Lock scrolling on the page to the specified element.
 * Prevents scrolling of all elements on the page other than those that are descendent of the given element.
 */


function scrollLock(element) {
  if (scrollLocks.indexOf(element) >= 0) {
    return;
  }

  if (scrollLocks.length === 0) {
    document.addEventListener('keydown', scrollLockHandlerKeyDown, true);
    document.addEventListener('wheel', scrollLockHandler, true);
    document.addEventListener('mousewheel', scrollLockHandler, true);
    document.addEventListener('touchstart', scrollLockHandler, true);
    document.addEventListener('touchmove', scrollLockHandler, true); // IE

    document.addEventListener('DOMMouseScroll', scrollLockHandler, true);
  }

  scrollLocks.push(element);
}
/**
 * Unlocks scrolling which was previously locked by the given element.
 */


function scrollUnlock(element) {
  const index = scrollLocks.indexOf(element);

  if (index === -1) {
    return;
  }

  scrollLocks.splice(index, 1);

  if (scrollLocks.length === 0) {
    document.removeEventListener('keydown', scrollLockHandlerKeyDown, true);
    document.removeEventListener('wheel', scrollLockHandler, true);
    document.removeEventListener('mousewheel', scrollLockHandler, true);
    document.removeEventListener('touchstart', scrollLockHandler, true);
    document.removeEventListener('touchmove', scrollLockHandler, true); // IE

    document.removeEventListener('DOMMouseScroll', scrollLockHandler, true);
  }
}
/**
 * Gets an x,y offset from a mouse event
 */


function getEventClientOffset(e) {
  let clientX;
  let clientY; // get the underlying event in the case of jquery

  const event = e.originalEvent || e;
  const touches = event.type === 'touchend' ? event.changedTouches : event.touches;

  if (touches && touches.length) {
    [{
      clientX,
      clientY
    }] = touches;
  } else {
    clientX = e.clientX;
    clientY = e.clientY;
  }

  return {
    x: clientX,
    y: clientY
  };
}
/**
 * Gets an x,y offset from nearest element
 */


function getNodeClientOffset(node) {
  const el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  const {
    top,
    left
  } = el.getBoundingClientRect();
  return {
    x: left,
    y: top
  };
}
/**
 * Gets the depth of a node within its tree
 */


function getNodeDepth(node) {
  let depth = 0;
  let n = node;

  while (n) {
    depth += 1;
    n = n.parentNode;
  }

  return depth;
}
/**
 * Get the center of the bounding rect of the element
 */


function getElementCenter(el) {
  const rect = el.getBoundingClientRect();
  const x = Math.round(rect.left + rect.width / 2);
  const y = Math.round(rect.top + rect.height / 2);
  return {
    x,
    y
  };
}
/**
 * Get the top left of the bounding rect of the element
 */


function getElementTopLeft(el) {
  const rect = el.getBoundingClientRect();
  const x = Math.round(rect.left);
  const y = Math.round(rect.top);
  return {
    x,
    y
  };
}
/**
 * Get the top left of the bounding rect of the element
 */


function getElementBottomLeft(el) {
  const rect = el.getBoundingClientRect();
  const x = Math.round(rect.left);
  const y = Math.round(rect.bottom);
  return {
    x,
    y
  };
}

function offsetWithinBoundingRect(clientOffset, boundingRect) {
  return clientOffset.x >= boundingRect.left && clientOffset.x < boundingRect.right && clientOffset.y >= boundingRect.top && clientOffset.y < boundingRect.bottom;
}

function applyAttributes(el, attrs) {
  const attrKeys = Object.keys(attrs);

  for (let i = 0; i < attrKeys.length; i++) {
    const attrKey = attrKeys[i];

    if (attrKey === 'style') {
      const style = attrs[attrKey];

      if (!style || typeof style !== 'object') {
        throw new Error('applyAttributes: Expected style to be an object');
      }

      const styleNames = Object.keys(style);

      for (let j = 0; j < styleNames.length; j++) {
        const styleName = styleNames[j];
        el.style[styleName] = style[styleName];
      }
    } else if (attrKey === 'className') {
      const className = attrs[attrKey];

      if (typeof className === 'string') {
        const classes = className.split(' ');

        for (let j = 0; j < classes.length; j++) {
          el.classList.add(classes[j]);
        }
      } else {
        // object
        Object.keys(className).forEach(cn => {
          if (className[cn]) {
            el.classList.add(cn);
          } else {
            el.classList.remove(cn);
          }
        });
      }
    } else if (attrKey === 'class') {
      throw new Error('applyAttributes: Unexpected attribute "class", use "className" instead.');
    } else {
      el.setAttribute(attrKey, attrs[attrKey]);
    }
  }
}
/**
 * Vertical cross browser support for experimental DOM API #scrollIntoViewIfNeeded
 * This function will only scroll vertically.
 */


function scrollIntoViewIfNeeded(scrollNode, node) {
  if (node.scrollIntoViewIfNeeded) {
    node.scrollIntoViewIfNeeded();
  } else {
    const sOffsetTop = scrollNode.offsetTop;
    const sScrollTop = scrollNode.scrollTop;
    const sClientHeight = scrollNode.clientHeight;
    const nOffsetTop = node.offsetTop;
    const nClientHeight = node.clientHeight;
    const nTop = nOffsetTop - sOffsetTop;
    const overTop = nTop < sScrollTop;

    if (overTop && nTop + nClientHeight > sScrollTop) {
      // move to top
      scrollNode.scrollTop = nTop;
    }

    const overBottom = nTop + nClientHeight > sScrollTop + sClientHeight;

    if (overBottom && nTop < sScrollTop + sClientHeight) {
      // move to bottom
      scrollNode.scrollTop = sScrollTop + (nTop + nClientHeight - (sScrollTop + sClientHeight));
    } else if (overTop || overBottom) {
      // center
      scrollNode.scrollTop = nTop - sClientHeight / 2 + nClientHeight / 2;
    }
  }
}

function isElementInView(el, parent = document.documentElement) {
  const rect = el.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  return rect.top >= parentRect.top && rect.left >= parentRect.left && rect.bottom <= parentRect.bottom && rect.right <= parentRect.right;
}
/**
 * Creates two headers so that only the elements between the two headers are tabable
 * Argument: tabEnabledArea: DOM element
 */


function enableFocusLoop(tabEnabledArea, index, ariaLabel) {
  const focusIndex = index || 0;
  let tabKeyPressed = false;
  const entryHeader = document.createElement('div');
  entryHeader.setAttribute('tabindex', '0');
  entryHeader.setAttribute('style', 'width: 0; height: 0; outline: none');

  if (ariaLabel) {
    entryHeader.setAttribute('aria-label', ariaLabel);
  }

  const exitHeader = document.createElement('div');
  exitHeader.setAttribute('tabindex', '0');
  exitHeader.setAttribute('style', 'width: 0; height: 0; outline: none');
  tabEnabledArea.insertBefore(entryHeader, tabEnabledArea.childNodes[0]);
  tabEnabledArea.appendChild(exitHeader);
  tabEnabledArea.addEventListener('keydown', e => {
    (0, _keyboardUtils.getKeyName)(e) === _keyboardUtils.keyNames.TAB && (tabKeyPressed = true, e.target.classList.remove((0, _classnames.default)('focus')));
  });
  const nodesArray = getFocusableElements(tabEnabledArea);
  const {
    activeElement
  } = document;
  (focusIndex < 0 || focusIndex > nodesArray.length - 2) && !tabEnabledArea.contains(activeElement) && setTimeout(() => entryHeader.focus(), 0);
  setTimeout(() => {
    tabEnabledArea.contains(activeElement) && activeElement.focus();
    entryHeader.addEventListener('focus', e => {
      e.preventDefault();
      const nodesArray = getFocusableElements(tabEnabledArea);

      if (tabKeyPressed) {
        nodesArray[nodesArray.length - 2].focus();
        tabKeyPressed = false;
      }
    }, 0);
    exitHeader.addEventListener('focus', e => {
      e.preventDefault();
      const nodesArray = getFocusableElements(tabEnabledArea);

      if (tabKeyPressed) {
        nodesArray[1].focus();
        tabKeyPressed = false;
      }
    });
  });
  focusIndex > -1 && focusIndex < nodesArray.length - 2 && !tabEnabledArea.contains(activeElement) && setFocus(nodesArray[focusIndex + 1]);
}

function resetFocusLoop(tabEnabledArea) {
  const nodesArray = getFocusableElements(tabEnabledArea);

  if (!tabEnabledArea.contains(document.activeElement)) {
    nodesArray[0].focus();
  }
}

function getFocusableElements(tabEnabledArea) {
  const focusableElements = tabEnabledArea.querySelectorAll('button:not([tabindex="-1"]):not([disabled]), [href]:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled]), select:not([tabindex="-1"]):not([disabled]), textarea:not([tabindex="-1"]):not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'); // filter out all svg items or elements with undefined 'focus' function

  return fromNodelistToArray(focusableElements).filter(item => !(item instanceof SVGElement || typeof item.focus !== 'function' || item.type === 'radio' && !item.checked));
}
/**
 * Calculates the available space for a flyout container and returns an object containing x and y locations
 * Argument: trigger: DOM element that triggers the flyout container,
 *           target: DOM element, the flyout container,
 *           defaultPosition (Optional): Object contains default x and y locations
 */


function availableSpace(element) {
  const elementRect = element.getBoundingClientRect();
  const availableRoomLeft = elementRect.left;
  const availableRoomRight = window.innerWidth - elementRect.right;
  const availableRoomTop = elementRect.top;
  const availableRoomBottom = window.innerHeight - elementRect.bottom;
  return {
    top: availableRoomTop,
    right: availableRoomRight,
    bottom: availableRoomBottom,
    left: availableRoomLeft
  };
}

function autoPosition(availableSpace, targetDimension, defaultPosition) {
  const targetHeight = targetDimension.height;
  const targetWidth = targetDimension.width;
  const possibleSpots = [];

  if (availableSpace.top >= targetHeight && availableSpace.right >= targetWidth / 2 && availableSpace.left >= targetWidth / 2) {
    possibleSpots.push('top');
  }

  if (availableSpace.bottom >= targetHeight && availableSpace.right >= targetWidth / 2 && availableSpace.left >= targetWidth / 2) {
    possibleSpots.push('bottom');
  }

  if (availableSpace.right >= targetWidth && availableSpace.top >= targetHeight / 2 && availableSpace.bottom >= targetHeight / 2) {
    possibleSpots.push('right');
  }

  if (availableSpace.left >= targetWidth && availableSpace.top >= targetHeight / 2 && availableSpace.bottom >= targetHeight / 2) {
    possibleSpots.push('left');
  }

  if (defaultPosition && (possibleSpots.indexOf(defaultPosition) > -1 || possibleSpots.length < 1)) {
    return defaultPosition;
  } else if (possibleSpots.length > 0) {
    return possibleSpots[0];
  }

  return 'top';
}

function fromNodelistToArray(nodelist) {
  return Array.prototype.slice.apply(nodelist);
}

function setFocus(focusableElement) {
  focusableElement.focus();
  focusableElement.classList.add((0, _classnames.default)('focus'));
}

function disableFocusLoop(tabEnabledArea) {
  const focusableElements = tabEnabledArea.querySelectorAll('[tabindex]:not([tabindex="-1"])');
  const nodesArray = fromNodelistToArray(focusableElements);
  nodesArray.forEach(item => {
    item.removeEventListener('focus', setFocus);
  });
  tabEnabledArea.removeEventListener('click', setFocus);
}
/**
 * Computes the position of an element - used for tooltip triggers
 * Argument: elem: DOM element that triggers the tooltip
 */


function computeTopWith(elem) {
  const box = elem.getBoundingClientRect();
  const {
    body
  } = document;
  const element = elem;
  const scrollTop = window.pageYOffset || element.scrollTop || body.scrollTop;
  const clientTop = element.clientTop || body.clientTop || 0;
  const top = box.top + scrollTop - clientTop;
  return Math.round(top);
}

function computeLeftWith(elem) {
  const box = elem.getBoundingClientRect();
  const {
    body
  } = document;
  const element = elem;
  const scrollLeft = window.pageXOffset || element.scrollLeft || body.scrollLeft;
  const clientLeft = element.clientLeft || body.clientLeft || 0;
  const left = box.left + scrollLeft - clientLeft;
  return Math.round(left);
}

function computeWidthOf(elem) {
  return Math.round(elem.getBoundingClientRect().width);
}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.sanitize = sanitize;
exports.getInheritedProps = getInheritedProps;
exports.getPassThroughProps = getPassThroughProps;
exports.BaPropTypes = void 0;

var _lodash = __webpack_require__(31);

var _Bidi = _interopRequireDefault(__webpack_require__(203));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function createError(propFullName, componentName) {
  return new Error(`Invalid prop '${propFullName}' supplied to '${componentName}'. Validation failed.`);
}

const BaPropTypes = {
  component(component) {
    return function (propValue, key, componentName, location, propFullName) {
      const prop = propValue[key];

      if (prop.type !== component && prop.type.name !== component.name) {
        return createError(propFullName, componentName);
      }

      return undefined;
    };
  },

  range(min, max) {
    return function (propValue, key, componentName, location, propFullName) {
      const value = propValue[key];

      if (value != null && (value < min || value > max)) {
        return createError(propFullName, componentName);
      }

      return undefined;
    };
  },

  notAllowed(notAllowedValues, message) {
    return function (propValue, key, componentName) {
      const value = propValue[key];
      let passed = true;

      for (let i = 0; i < notAllowedValues.length; i++) {
        if (value === notAllowedValues[i]) {
          passed = false;
          break;
        }
      }

      if (value != null && !passed) {
        return new Error(`Invalid prop '${key}' supplied to '${componentName}'. ${message || ''}`);
      }

      return undefined;
    };
  },

  deprecated(message) {
    return function (propValue, key, componentName) {
      const value = propValue && propValue[key];

      if (value != null) {
        return new Error(`'${key}' supplied to '${componentName}' is deprecated . ${message || ''}`);
      }

      return undefined;
    };
  },

  deprecatedByCarbon(Component) {
    BaPropTypes.deprecated(`It is ignored and not applicable to Carbon ${Component.name}`);
  },

  requiredIf(typeCheck, condition) {
    return function (props, propName, componentName, ...other) {
      // if condition is not provided we will assume required is true
      const isRequired = typeof condition === 'function' ? condition(props, propName, componentName) : true;

      if (!typeCheck) {
        return new Error(`Unable to validate ${propName} for ${componentName}, type check method not provided.`);
      }

      const check = isRequired ? typeCheck.isRequired : typeCheck;
      return check(props, propName, componentName, ...other);
    };
  }

};
exports.BaPropTypes = BaPropTypes;

function sanitize(props, Component, ...blackList) {
  // Predefined blackList, can be added more if needed
  const defaultBlackList = [...(Component ? Object.keys(Component.propTypes) : []), ..._Bidi.default.getBidiProps()];
  const blackLists = [...blackList, ...defaultBlackList];
  return (0, _lodash.omit)(props, ...blackLists);
}

function getInheritedProps(props, SuperClass) {
  return (0, _lodash.pick)(props, [...Object.keys(SuperClass.propTypes)]);
}

function getPassThroughProps(others, propertiesPaneObject) {
  const propertiesPanePassthroughProps = getInheritedProps(others, propertiesPaneObject);
  return {
    propertiesPanePassthroughProps,
    others: (0, _lodash.omit)(others, Object.keys(propertiesPanePassthroughProps))
  };
}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.cssSize = cssSize;
exports.sizeArrayToCss = sizeArrayToCss;
exports.mergeStyles = mergeStyles;
exports.sizeStep = void 0;

var _lodash = __webpack_require__(31);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const sizeStep = 8;
exports.sizeStep = sizeStep;

function cssSize(n) {
  return n * sizeStep;
}

function sizeArrayToCss(sizeArray) {
  if (sizeArray == null) {
    return sizeArray;
  }

  const arr = Array.isArray(sizeArray) ? sizeArray : [+sizeArray];
  return arr.length ? `${arr.map(v => v * sizeStep).join('px ')}px` : null;
}

function mergeStyles(a, b) {
  if (!b) {
    return a;
  }

  const styles = { ...a
  };
  (0, _lodash.forIn)(b, (value, key) => {
    if (styles[key] == null && value != null) {
      styles[key] = value;
    }
  });
  return styles;
}

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.decimalPlaces = decimalPlaces;
exports.decimalMultiply = decimalMultiply;
exports.decimalPlus = decimalPlus;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function decimalPlaces(number) {
  if (Math.floor(number) === number) {
    return 0;
  }

  return number.toString().split('.')[1].length || 0;
}

function decimalMultiply(a, b) {
  const powerOf10a = 10 ** decimalPlaces(a);
  const powerOf10b = 10 ** decimalPlaces(b);
  return a * powerOf10a * (b * powerOf10b) / (powerOf10a * powerOf10b);
}

function decimalPlus(a, b) {
  const powerOf10 = 10 ** Math.max(decimalPlaces(a), decimalPlaces(b));
  return (a * powerOf10 + b * powerOf10) / powerOf10;
}

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getSelected = getSelected;
exports.indexKeyGetter = indexKeyGetter;
exports.singleSelect = singleSelect;
exports.clear = clear;
exports.invert = invert;
exports.multiSelect = multiSelect;

var _constants = __webpack_require__(27);

var _lodash = __webpack_require__(31);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  selectionEventTypes
} = _constants.listEventTypes;
/**
 * Get the array of selected data elements from the provided selection map.
 *
 * @param {Object} selectedMap a map of selected values
 *
 * @return {Object[]} an array of selected data elements
 */

function getSelected(selectedMap) {
  const result = [];
  (0, _lodash.forOwn)(selectedMap, (value, i) => {
    if (selectedMap[i] != null) {
      result.push(selectedMap[i]);
    }
  });
  return result;
}
/**
 * A key getter that simply returns the index provided.
 *
 * @param {number} index the index of the data element
 *
 * @return {number} the index of the data element
 */


function indexKeyGetter(index) {
  return index;
}
/**
 * Handles events for single selection mode lists.
 *
 * @param {Object} event the list selection event
 * @param {Object[]} data the array of data elements
 * @param {string} selectedKey the current selected key value
 * @param {keyGetterCallback} keyGetter
 *
 * @return {string} the key of the selected element
 */


function singleSelect(event, data, selectedKey, keyGetter) {
  const getter = keyGetter || indexKeyGetter;
  const key = getter(event.index);

  if (event.type === selectionEventTypes.TOGGLE && selectedKey === key) {
    return null;
  }

  return key;
}
/**
 * Clears all data elements from the given selection map.
 *
 * @param {Object[]} data the array of data elements to clear
 * @param {Object} selectedMap a map of selected values
 * @param {keyGetterCallback} keyGetter
 * @param {Object} omit a map of items to omit from changing selection
 *
 * @return {Object} the new selection map
 */


function clear(data, selectedMap, keyGetter, omit) {
  const getter = keyGetter || indexKeyGetter;
  const newSelection = { ...selectedMap
  };
  data.forEach((d, i) => {
    const key = getter(i);

    if (selectedMap[key] && (!omit || !omit[key])) {
      newSelection[key] = null;
    }
  });
  return newSelection;
}
/**
 * Inverts the selection of all data elements from the given selection map.
 *
 * @param {Object[]} data the array of data elements to invert
 * @param {Object} selectedMap a map of selected values
 * @param {keyGetterCallback} keyGetter
 * @param {Object} omit a map of items to omit from changing selection
 *
 * @return {Object} the new selection map
 */


function invert(data, selectedMap, keyGetter, omit) {
  const getter = keyGetter || indexKeyGetter;
  const newSelection = { ...selectedMap
  };
  data.forEach((d, i) => {
    const key = getter(i);

    if (!omit || !omit[key]) {
      if (!selectedMap[key]) {
        newSelection[key] = data[i];
      } else {
        newSelection[key] = null;
      }
    }
  });
  return newSelection;
}
/**
 * Handles events for multi selection mode lists.
 *
 * @param {Object} event the list selection event
 * @param {Object[]} data the array of data elements
 * @param {string} selectedKey the current selected key value
 * @param {keyGetterCallback} keyGetter
 * @param {Object} omit a map of items to omit from changing selection
 *
 * @return {string} the key of the selected element
 */


function multiSelect(event, data, selectedMap, keyGetter, omit) {
  const eventType = event.type;
  const getter = keyGetter || indexKeyGetter;
  const result = {
    selectedCount: 0,
    deselectedCount: 0
  };
  let rselectedMap = selectedMap;
  let key;
  const {
    index
  } = event;

  switch (eventType) {
    case selectionEventTypes.SET:
      key = getter(index);

      if (!omit) {
        const total = Object.keys(selectedMap).length;

        if (total !== 1 || !selectedMap[key]) {
          rselectedMap = {
            [key]: data[index]
          };
          result.selected = data[index];
          result.selectedCount = 1;
          result.deselectedCount = total;
        }
      } else if (!omit[key] && !selectedMap[key]) {
        rselectedMap = { ...selectedMap
        };
        result.selected = data[index];
        rselectedMap[key] = data[index];
        result.selectedCount = 1;
      }

      break;

    default:
      rselectedMap = { ...selectedMap
      };

      switch (eventType) {
        case selectionEventTypes.ADD:
          key = getter(index);

          if (!rselectedMap[key] && (!omit || !omit[key])) {
            rselectedMap[key] = data[index];
            result.selected = data[index];
            result.selectedCount = 1;
          }

          break;

        case selectionEventTypes.REMOVE:
          key = getter(index);

          if (rselectedMap[key] && (!omit || !omit[key])) {
            delete rselectedMap[key];
            result.deselected = data[index];
            result.deselectedCount = 1;
          }

          break;

        case selectionEventTypes.COMPOSITE:
          if (event.added) {
            event.added.forEach(i => {
              key = getter(i);

              if (!rselectedMap[key] && (!omit || !omit[key])) {
                rselectedMap[key] = data[i];
                result.selected = data[index];
                result.selectedCount += 1;
              }
            });
          }

          if (event.removed) {
            event.removed.forEach(i => {
              key = getter(i);

              if (rselectedMap[key] && (!omit || !omit[key])) {
                delete rselectedMap[key];
                result.deselected = data[index];
                result.deselectedCount += 1;
              }
            });
          }

          break;

        case selectionEventTypes.TOGGLE:
          key = getter(index);

          if (!omit || !omit[key]) {
            if (rselectedMap[key]) {
              delete rselectedMap[key];
              result.deselected = data[index];
              result.deselectedCount = 1;
            } else {
              rselectedMap[key] = data[index];
              result.selected = data[index];
              result.selectedCount = 1;
            }
          }

          break;

        case selectionEventTypes.SELECT_ALL:
          data.forEach((d, i) => {
            key = getter(i);

            if (!rselectedMap[key] && (!omit || !omit[key])) {
              rselectedMap[key] = data[i];
              result.selected = data[index];
              result.selectedCount += 1;
            }
          });
          break;

        default:
      }

  }

  result.selectedMap = rselectedMap;
  return result;
}

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.startsWithFilter = startsWithFilter;
exports.containsFilter = containsFilter;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/**
 * Adds common input pre-processing for filter functions.
 *
 * @param inputParam {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @param filterFn {Function} - array filter function to call
 * @returns {Function} - new array filter function with common pre-processing
 */
function createFilter(inputParam = '', caseSensitive = false, filterFn) {
  let input = inputParam;
  return function (valueParam = '') {
    let value = valueParam; // value could be a string or an object from a comboBox - { value, label }

    value = typeof value === 'string' ? value : value.label || '';
    input = input.trim();

    if (!caseSensitive) {
      value = value.toLowerCase();
      input = input.toLowerCase();
    }

    if (value === input) {
      return true;
    }

    return filterFn(input, value);
  };
}
/**
 * Creates a 'starts with' array filter function
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @returns {Function} - array filter function
 */


function startsWithFilter(input, caseSensitive) {
  return createFilter(input, caseSensitive, (input, value) => value.substring(0, input.length) === input);
}
/**
 * Creates a 'contains' array filter function
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @returns {Function} - array filter function
 */


function containsFilter(input, caseSensitive) {
  return createFilter(input, caseSensitive, (input, value) => value.indexOf(input) >= 0);
}

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _nodePolyglot = _interopRequireDefault(__webpack_require__(605));

var _DefaultResources = _interopRequireDefault(__webpack_require__(606));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
const StringResource = function (resources) {
  const allResources = Object.assign({}, _DefaultResources.default, resources);
  this._polyglot = new _nodePolyglot.default({
    phrases: allResources
  });
};
/**
 * Get the string resource for the given key and interpolation options
 *
 * @param key The  key of the string to return
 * @param interpolationOptions Optional interpolation options (see poly.t documentation for details)
 * @returns The string to display
 */


StringResource.prototype.get = function (key, interpolationOptions) {
  let translated = this._polyglot.t(key, interpolationOptions);

  if (this._polyglot.phrases[key] === undefined) {
    translated = `__NOT_TRANSLATED__(${key})`;
  }

  return translated;
};

var _default = StringResource;
exports.default = _default;

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports = require("node-polyglot");

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

var amdi18n={"__root":{},"__cs":{},"__da":{},"__de":{},"__es":{},"__fi":{},"__fr":{},"__hr":{},"__hu":{},"__it":{},"__ja":{},"__kk":{},"__ko":{},"__nb":{},"__nl":{},"__no":{},"__pl":{},"__pt":{},"__pt-br":{},"__ro":{},"__ru":{},"__sl":{},"__sv":{},"__th":{},"__tr":{},"__zh":{},"__zh-cn":{},"__zh-tw":{}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.stopEvent = stopEvent;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-carbon-toolkit (C) Copyright IBM Corp. 2016, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
function stopEvent(e) {
  // eslint-disable-line import/prefer-default-export
  e.preventDefault();
  e.stopPropagation();
}

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = _default;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _default(CustomElement, {
  events = {},
  mapAttributes = () => ({}),
  mapProperties = () => ({}),
  onRender,
  onUnmount
}) {
  let tagName;

  const getTagName = () => tagName || (tagName = new CustomElement().tagName);

  function isNativeEvent(eventName) {
    return eventName.indexOf('on') === 0 && eventName[2] === eventName[2].toUpperCase() && !events[eventName];
  }

  class Comp extends _react.default.Component {
    static get displayName() {
      return getTagName();
    }

    componentDidMount() {
      this.componentWillReceiveProps(this.props, {});
    }

    componentWillReceiveProps(props, prevProps) {
      const node = _reactDom.default.findDOMNode(this);

      const properties = mapProperties(props);
      Object.keys(props).forEach(name => {
        if (props[name] !== prevProps[name]) {
          if (events[name]) {
            if (prevProps[name]) {
              node.removeEventListener(events[name], prevProps[name]);
            }

            node.addEventListener(events[name], props[name]);
          } else if (properties[name]) {
            node[name] = props[name];
          }
        }
      });
      onRender && onRender.call(this, node, props);
    }

    componentWillUnmount() {
      const node = _reactDom.default.findDOMNode(this);

      Object.keys(events).forEach(name => {
        node.removeEventListener(events[name], this.props[name]);
      });
      onUnmount && onUnmount.call(this, node, this.props);
    }

    render() {
      const props = mapAttributes(this.props); // Pass down native react events (eg. onClick) so that they can be handled
      // by reacts syntethic events system

      Object.keys(this.props).forEach(name => {
        if (isNativeEvent(name)) {
          props[name] = this.props[name];
        }
      });
      return _react.default.createElement(getTagName(), props);
    }

  }

  (0, _defineProperty2.default)(Comp, "propTypes", { ...Object.keys(events).reduce((types, name) => {
      types[name] = _propTypes.default.func;
      return types;
    }, {})
  });
  return Comp;
}

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = _default;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _lodash = __webpack_require__(31);

var _hoistNonReactInstanceFunctions = _interopRequireDefault(__webpack_require__(204));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _default(defaultDelay = 250) {
  return function (WrappedComponent) {
    class DelayMount extends _react.Component {
      constructor(...args) {
        super(...args);
        (0, _defineProperty2.default)(this, "state", {
          mount: this.props.delay <= 0
        });
        (0, _defineProperty2.default)(this, "_ref", wc => {
          wc && (0, _hoistNonReactInstanceFunctions.default)(this, wc);
        });
      }

      componentDidMount() {
        if (!this.state.mount) {
          this._handle = setTimeout(() => {
            delete this._handle;
            this.setState({
              mount: true
            });
          }, this.props.delay);
        }
      }

      componentWillUnmount() {
        this._handle && clearTimeout(this._handle);
      }

      render() {
        const {
          mount
        } = this.state;

        if (!mount) {
          return null;
        }

        const props = (0, _lodash.omit)(this.props, 'delay');
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
          ref: this._ref
        }));
      }

    }

    (0, _defineProperty2.default)(DelayMount, "propTypes", {
      delay: _propTypes.default.number
    });
    (0, _defineProperty2.default)(DelayMount, "defaultProps", {
      delay: defaultDelay
    });
    DelayMount.WrappedComponent = WrappedComponent;
    return DelayMount;
  };
}

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = _default;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _lodash = __webpack_require__(31);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _default(defaultDelay = 0) {
  return Comp => {
    var _class, _temp;

    return _temp = _class = class DebounceInput extends _react.Component {
      constructor(...args) {
        super(...args);
        (0, _defineProperty2.default)(this, "state", {
          value: this.props.value
        });
        (0, _defineProperty2.default)(this, "_debouncer", null);
        (0, _defineProperty2.default)(this, "_refreshDebouncer", true);
        (0, _defineProperty2.default)(this, "_notify", value => {
          this.props.onChange && this.props.onChange(value);
        });
        (0, _defineProperty2.default)(this, "_onKeyDown", e => {
          if (e.keyCode === 13) {
            this._debouncer && this._debouncer.flush();
          }

          this.props.onKeyDown && this.props.onKeyDown(e);
        });
        (0, _defineProperty2.default)(this, "_onBlur", e => {
          this._debouncer && this._debouncer.flush();
          this.props.onBlur && this.props.onBlur(e);
        });
        (0, _defineProperty2.default)(this, "_onChange", value => {
          this.setState({
            value
          });

          if (this._refreshDebouncer) {
            const {
              delay
            } = this.props;
            this._debouncer && this._debouncer.cancel();
            this._debouncer = (0, _lodash.debounce)(this._notify, delay);
            this._refreshDebouncer = false;
          }

          this._debouncer(value);
        });
        (0, _defineProperty2.default)(this, "_onClear", () => {
          this._debouncer && this._debouncer.flush();
          this.props.onClear && this.props.onClear();
        });
        (0, _defineProperty2.default)(this, "_ref", input => {
          this._input = input;
        });
      }

      componentWillReceiveProps({
        value,
        delay
      }) {
        if (delay !== this.props.delay) {
          this._refreshDebouncer = true;
        }

        if (value === this.state.value || value !== this.props.value) {
          this._debouncer && this._debouncer.cancel();
          this.setState({
            value
          });
        }
      }

      componentWillUnmount() {
        this._debouncer && this._debouncer.cancel();
      }

      focus() {
        this._input && this._input.focus && this._input.focus();
      }

      render() {
        const other = (0, _lodash.omit)(this.props, 'delay');
        const {
          value
        } = this.state;
        return /*#__PURE__*/_react.default.createElement(Comp, (0, _extends2.default)({}, other, {
          ref: this._ref,
          value: value,
          onBlur: this._onBlur,
          onClear: this._onClear,
          onChange: this._onChange,
          onKeyDown: this._onKeyDown
        }));
      }

    }, (0, _defineProperty2.default)(_class, "propTypes", { ...Comp.propTypes,
      delay: _propTypes.default.number,
      value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
      onKeyDown: _propTypes.default.func,
      onChange: _propTypes.default.func,
      onBlur: _propTypes.default.func,
      onClear: _propTypes.default.func
    }), (0, _defineProperty2.default)(_class, "defaultProps", { ...Comp.defaultProps,
      delay: defaultDelay
    }), _temp;
  };
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ })

},[[594,0]]]);
});